//membership offer card with plus button
import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
  useCallback,
} from "react";

import {
  getMembershipOffers,
  getMembershipOfferCount,
  createMembershipOffer,
  updateMembershipOffer,
  deleteMembershipOffers,
} from "../helper/api";
import { isAuthenticated } from "../../../auth";

import MembershipOfferModal from "../components/plusButtonPopup";
import Toast from "../../../lib/toast";
import "../style.scss";

/* ---------------- Icons ---------------- */

const CardIcon = ({ size = 26 }) => (
  <svg width={size} height={size} viewBox="0 0 171 171" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M28.5 89.6111V102.493C28.5 103.586 28.956 104.59 29.868 105.507C30.78 106.424 31.7846 106.88 32.8819 106.875H138.118C139.211 106.875 140.215 106.419 141.132 105.507C142.049 104.595 142.505 103.588 142.5 102.486V89.6111H28.5ZM32.8819 21.375H138.118C141.301 21.375 144.015 22.496 146.262 24.738C148.504 26.98 149.625 29.697 149.625 32.889V102.493C149.625 105.676 148.504 108.39 146.262 110.637C144.02 112.879 141.305 114 138.118 114H106.326V144.424L85.5 134L64.6736 144.41V114H32.889C29.697 114 26.98 112.879 24.738 110.637C22.496 108.395 21.375 105.68 21.375 102.493V32.8819C21.375 29.6994 22.496 26.9847 24.738 24.738C26.98 22.496 29.697 21.375 32.889 21.375M28.5 74.2639H142.5V32.889C142.5 31.7918 142.044 30.7847 141.132 29.868C140.22 28.9512 139.215 28.4953 138.118 28.5H32.8819C31.7894 28.5 30.7847 28.956 29.868 29.868C28.9512 30.78 28.4953 31.7846 28.5 32.8819V74.2639ZM28.5 102.493V28.5H32.889C31.7918 28.5 30.7847 28.956 29.868 29.868C28.9512 30.78 28.4953 31.7846 28.5 32.8819V102.493ZM28.5 102.493C28.5 103.586 28.956 104.59 29.868 105.507C30.78 106.424 31.7846 106.88 32.8819 106.875H28.5V102.493Z" fill="#055075" />
  </svg>
);

const EditIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.5 1.5L12.5 4.5L4.5 12.5H1.5V9.5L9.5 1.5Z" stroke="#5A4A45" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const TrashIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 3.5H12M5.5 3.5V2C5.5 1.5 5.9 1 6.5 1H7.5C8.1 1 8.5 1.5 8.5 2V3.5M11 3.5L10.5 12C10.45 12.55 10 13 9.4 13H4.6C4 13 3.55 12.55 3.5 12L3 3.5"
      stroke="#5A4A45" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PlusIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 4V20M4 12H20" stroke="#FFFFFF" strokeWidth="2.6" strokeLinecap="round" />
  </svg>
);

/* Decorative wave + watermark background */
const CardBackground = () => (
  <>
    <svg
      className="membership-offers__bg-svg-top"
      viewBox="0 0 326 165"
      preserveAspectRatio="none"
    >
      <path
        d="M1.26691e-09 19.9413C5.89045e-10 8.8956 8.95431 0 20 0H306C317.046 0 326 8.95431 326 20V43.7111C320.232 44.1911 266.779 89.4204 156.021 89.4204C89.7248 89.4204 1.54187e-09 181.82 5.54744e-09 162.289C8.6183e-09 147.316 3.72014e-09 59.9161 1.26691e-09 19.9413Z"
        fill="#F3D9D0"
      />
    </svg>
    <svg
      className="membership-offers__bg-svg-watermark"
      viewBox="0 0 400 620"
      preserveAspectRatio="none"
    >
      <g transform="translate(200,300)" opacity="0.6">
        <path
          transform="translate(-72,-72) scale(0.84)"
          d="M28.5 89.6111V102.493C28.5 103.586 28.956 104.59 29.868 105.507C30.78 106.424 31.7846 106.88 32.8819 106.875H138.118C139.211 106.875 140.215 106.419 141.132 105.507C142.049 104.595 142.505 103.588 142.5 102.486V89.6111H28.5ZM32.8819 21.375H138.118C141.301 21.375 144.015 22.496 146.262 24.738C148.504 26.98 149.625 29.697 149.625 32.889V102.493C149.625 105.676 148.504 108.39 146.262 110.637C144.02 112.879 141.305 114 138.118 114H106.326V144.424L85.5 134L64.6736 144.41V114H32.889C29.697 114 26.98 112.879 24.738 110.637C22.496 108.395 21.375 105.68 21.375 102.493V32.8819C21.375 29.6994 22.496 26.9847 24.738 24.738C26.98 22.496 29.697 21.375 32.889 21.375M28.5 74.2639H142.5V32.889C142.5 31.7918 142.044 30.7847 141.132 29.868C140.22 28.9512 139.215 28.4953 138.118 28.5H32.8819C31.7894 28.5 30.7847 28.956 29.868 29.868C28.9512 30.78 28.4953 31.7846 28.5 32.8819V74.2639ZM28.5 102.493V28.5H32.889C31.7918 28.5 30.7847 28.956 29.868 29.868C28.9512 30.78 28.4953 31.7846 28.5 32.8819V102.493ZM28.5 102.493C28.5 103.586 28.956 104.59 29.868 105.507C30.78 106.424 31.7846 106.88 32.8819 106.875H28.5V102.493Z"
          fill="#E3CEC4"
        />
      </g>
    </svg>
  </>
);

/* ---------------- Helpers ---------------- */

const extractErrorMessage = (res, fallback) => {
  if (!res || !res.error) return fallback;
  const err = res.error;
  if (typeof err === "string") return err;
  if (err.message) {
    const fields = res.emptyFields ? ` (${res.emptyFields.join(", ")})` : "";
    return `${err.message}${fields}`;
  }
  if (res.emptyFields) return `Invalid payload: missing ${res.emptyFields.join(", ")}`;
  return fallback;
};

/* ---------------- Component ---------------- */

const MembershipOffers = forwardRef(({ selectedGym = null }, ref) => {
  const [offers, setOffers] = useState([]);
  const [offersLoading, setOffersLoading] = useState(false);
  const [offersError, setOffersError] = useState(null);

  const [showOfferModal, setShowOfferModal] = useState(false);
  const [editingOffer, setEditingOffer] = useState(null);

  const getBranchId = () => selectedGym?.branchId || selectedGym?._id || null;

  const fetchOffers = useCallback(async () => {
    const branchId = getBranchId();
    if (!branchId) {
      setOffers([]);
      setOffersError(null);
      return;
    }

    setOffersLoading(true);
    setOffersError(null);

    try {
      const auth = isAuthenticated();
      if (!auth) {
        setOffersError("You must be signed in to load offers.");
        setOffersLoading(false);
        return;
      }
      const { token, user } = auth;
      const userId = user._id;

      const countRes = await getMembershipOfferCount(userId, token, { branchId });
      if (countRes?.error) {
        throw new Error(extractErrorMessage(countRes, "Failed to load offer count."));
      }
      const total = countRes?.COUNT ?? 0;

      const offersRes = await getMembershipOffers(userId, token, {
        branchId,
        limit: total || 100,
        page: 1,
      });

      if (offersRes?.error) {
        throw new Error(extractErrorMessage(offersRes, "Failed to load offers."));
      }

      const fetched = Array.isArray(offersRes) ? offersRes : [];

      const normalized = fetched.map((o) => {
        const plan = o.membershipId || {};
        const pkg = (plan.packages && plan.packages[0]) || {};
        const durationLabel =
          pkg.duration != null && pkg.durationType
            ? `${pkg.duration} ${pkg.durationType}${pkg.duration > 1 ? "s" : ""}`
            : "";
        const amount = Number(pkg.basePrice ?? 0);
        const isPercentageDiscount = Number(o.amountInPercentage || 0) > 0;
        const discountAmount = isPercentageDiscount
          ? Math.round((amount * (o.amountInPercentage || 0)) / 100)
          : Number(o.amountInValue || 0);

        return {
          id: String(o._id),
          planId: String(plan._id ?? plan.id ?? o.membershipId ?? ""),
          planName: plan.name ?? "—",
          offerTitle: o.offerTitle ?? "",
          duration: durationLabel,
          session: pkg.sessions ?? 0,
          amount,
          isPercentageDiscount,
          discountValue: isPercentageDiscount ? o.amountInPercentage : o.amountInValue,
          discountAmount,
          startDateTime: o.startDateTime ?? "",
          endDateTime: o.endDateTime ?? "",
        };
      });

      setOffers(normalized);
    } catch (err) {
      console.error("Failed to fetch membership offers:", err);
      setOffersError(err.message || "Failed to load offers. Please try again.");
    } finally {
      setOffersLoading(false);
    }
  }, [selectedGym]);

  useEffect(() => {
    fetchOffers();
  }, [fetchOffers]);

  const handleOpenCreateOffer = () => {
    setEditingOffer(null);
    setShowOfferModal(true);
  };

  const handleOpenEditOffer = (offer) => {
    setEditingOffer(offer);
    setShowOfferModal(true);
  };

  const handleCloseModal = () => {
    setShowOfferModal(false);
    setEditingOffer(null);
  };

  useImperativeHandle(ref, () => ({
    openCreateOffer: handleOpenCreateOffer,
  }));

const handleRemoveOffer = async (offerId) => {
  const auth = isAuthenticated();
  if (!auth) return;
  const { token, user } = auth;
  const userId = user._id;

  try {
    const res = await deleteMembershipOffers(userId, token, {
      membership_offer_ids: [offerId],
    });
    if (res?.error) {
      throw new Error(extractErrorMessage(res, "Failed to delete offer."));
    }
    setOffers((prev) => prev.filter((o) => o.id !== offerId));

    new Toast({
      type: "success",
      duration: 3000,
      message: "Offer removed",
    });
  } catch (err) {
    console.error("Failed to delete membership offer:", err);
    setOffersError(err.message || "Failed to delete offer. Please try again.");

    new Toast({
      type: "error",
      duration: 3000,
      message: err.message || "Failed to delete offer",
    });
  }
};

  const handleSaveOffer = async (payload) => {
    const auth = isAuthenticated();
    if (!auth) return;
    const { token, user } = auth;
    const userId = user._id;

    const branchId = getBranchId();
    if (!branchId) {
      setOffersError("Please select a gym/branch first.");
      return;
    }

    const discountValueNum = Number(payload.discountValue) || 0;

    const body = {
      membershipId: payload.planId,
      branchId,
      offerTitle: payload.offerTitle,
      amountInPercentage: payload.isPercentageDiscount ? discountValueNum : 0,
      amountInValue: !payload.isPercentageDiscount ? discountValueNum : 0,
      startDateTime: payload.startDateTime,
      endDateTime: payload.endDateTime,
    };

    try {
      let res;
      if (editingOffer) {
        res = await updateMembershipOffer(userId, token, editingOffer.id, body);
      } else {
        res = await createMembershipOffer(userId, token, body);
      }

      if (res?.error) {
        throw new Error(extractErrorMessage(res, "Failed to save offer."));
      }

      await fetchOffers();
      handleCloseModal();
    } catch (err) {
      console.error("Failed to save membership offer:", err);
      setOffersError(err.message || "Failed to save offer. Please try again.");
    }
  };

  const renderStatus = (text, isError = false) => (
    <div className={`membership-offers__status${isError ? " membership-offers__status--error" : ""}`}>
      {text}
    </div>
  );

  let listContent;
  if (offersLoading) {
    listContent = renderStatus("Loading offers…");
  } else if (offersError) {
    listContent = renderStatus(offersError, true);
  } else if (!getBranchId()) {
    listContent = renderStatus("Select a gym/branch to view offers.");
  } else if (offers.length === 0) {
    listContent = renderStatus("No offers created yet.");
  } else {
    listContent = offers.map((offer, idx) => {
      const discountedPrice = Math.max((offer.amount || 0) - (offer.discountAmount || 0), 0);
      return (
        <div key={offer.id}>
          <div className="membership-offers__item">
            <div className="membership-offers__item-header">
              <p className="membership-offers__item-name">{offer.planName || "—"}</p>
              <div className="membership-offers__item-actions">
                <button
                  className="membership-offers__icon-btn membership-offers__icon-delete"
                  onClick={() => handleRemoveOffer(offer.id)}
                  aria-label="Delete"
                >
                  <TrashIcon />
                </button>
                <button
                  className="membership-offers__icon-btn membership-offers__icon-edit"
                  onClick={() => handleOpenEditOffer(offer)}
                  aria-label="Edit"
                >
                  <EditIcon />
                </button>
              </div>
            </div>

            <div className="membership-offers__info-box">
              <div className="membership-offers__top-section">
                <div className="membership-offers__row">
                  <span className="membership-offers__label">Duration</span>
                  <span className="membership-offers__value">{offer.duration || "—"}</span>
                </div>
                <div className="membership-offers__row">
                  <span className="membership-offers__label">Session</span>
                  <span className="membership-offers__value">{offer.session ?? "—"}</span>
                </div>
              </div>
              <div className="membership-offers__bottom-section">
                <div className="membership-offers__row">
                  <span className="membership-offers__label">Price</span>
                  <span>
                    <span className="membership-offers__price-new">₹ {discountedPrice}</span>
                    <span className="membership-offers__price-old">₹ {offer.amount}</span>
                  </span>
                </div>
                <div className="membership-offers__row">
                  <span className="membership-offers__label">Discount Applied</span>
                  <span className="membership-offers__discount">₹ {offer.discountAmount || 0}</span>
                </div>
              </div>
            </div>
          </div>

          {idx !== offers.length - 1 && <hr className="membership-offers__divider" />}
        </div>
      );
    });
  }

  return (
    <>
      <div className="membership-offers">
        <CardBackground />

        <div className="membership-offers__header">
          <div className="membership-offers__header-left">
            <CardIcon />
            <p className="membership-offers__title">Active Membership Offers</p>
          </div>
          <div className="membership-offers__header-right">
            <button
              className="membership-offers__add-btn"
              onClick={handleOpenCreateOffer}
              aria-label="Add membership offer"
            >
              <PlusIcon />
            </button>
            <span className="membership-offers__badge">{offers.length}</span>
          </div>
        </div>

        <div className="membership-offers__scroll">
          {listContent}
        </div>
      </div>

      {showOfferModal && (
        <MembershipOfferModal
          initialData={editingOffer}
          onClose={handleCloseModal}
          onSave={handleSaveOffer}
        />
      )}
    </>
  );
});

export default MembershipOffers;